import type {FC} from 'react';
import {useAttentionCounts} from '../../../../core/usecases/useAttentionCounts';
import {EngineerHeaderPresentation} from './presentation';

type Props = {
  className?: string;
};

export const EngineerHeaderContainer: FC<Props> = ({className}) => {
  const {scoutsCount, interestsCount} = useAttentionCounts();

  return (
    <EngineerHeaderPresentation
      className={className}
      scoutsCount={scoutsCount}
      interestsCount={interestsCount}
    />
  );
};
